var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('earth-layout',[_c('template',{slot:"A"},[_c('dynamic-categories-list',{key:_vm.brandId,attrs:{"routes":_vm.routes()}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }